import { render, staticRenderFns } from "./ppbi.vue?vue&type=template&id=06f8c17d&scoped=true&"
import script from "./ppbi.vue?vue&type=script&lang=js&"
export * from "./ppbi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f8c17d",
  null
  
)

export default component.exports